import React from "react";
import { BookDemoButton } from "components/event-tracking";
import { FillImage } from "components/images";
import { MediaAccordion } from "ui/accordion";
import { SolidPlate } from "ui/plates";
import { TextTitle } from "ui/text";
import identitiesAccordionImage1 from "../../../../public/assets/platform/identity-resolution/identities-accordion-image-1.png";
import identitiesAccordionImage2 from "../../../../public/assets/platform/identity-resolution/identities-accordion-image-2.png";
import identitiesAccordionImage3 from "../../../../public/assets/platform/identity-resolution/identities-accordion-image-3.png";
import identitiesAccordionImage4 from "../../../../public/assets/platform/identity-resolution/identities-accordion-image-4.png";

export function IdentitiesExplainer() {
  return (
    <SolidPlate theme="dark" bgColor="new.blue.950" spotlightColor="new.blue.900">
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title="Build profiles for any type of identity"
        description="Create identity and entity profiles tailored to exactly what your business needs. Easily build and manage multiple identity graphs for different use cases."
        actions={<BookDemoButton isLink text="Learn more" />}
      />

      <MediaAccordion
        theme="dark"
        size="lg"
        direction="right"
        variant="dynamic"
        mt={{ base: "big", md: "huge" }}
        items={[
          {
            title: "High-confidence identities",
            content:
              "Merge profiles with precise rules on high-quality identifiers to make sure you have accurate data for each customer. Make sure that personalized emails and communications go to the right people.",
            media: (
              <FillImage
                src={identitiesAccordionImage1}
                alt="Illustration showing a personalized email being matched with the correct customer profile."
              />
            ),
          },
          {
            title: "High-reach identities",
            content:
              "Merge profiles using looser rules on the full breadth of identifiers you have, to build bigger audiences for advertising platforms and other broad-reach campaigns.",
            media: (
              <FillImage
                src={identitiesAccordionImage2}
                alt="Illustration showing seven different customer profiles being merged into one group by a set of four anonymized identifiers for email address, anonymous ID, device ID, and user ID."
              />
            ),
          },
          {
            title: "Custom entities",
            content:
              "Merge profiles for any entity that matters for your business, such as households, accounts, pets, or insurance policies.",
            media: (
              <FillImage
                src={identitiesAccordionImage3}
                alt="Illustration showing three circles that represent sample custom entities: one for a household, one for a single identity, and one for shopping accounts."
              />
            ),
          },
          {
            title: "Build multiple identity graphs",
            content:
              "Build as many identity resolution graphs as you need. For example, you can use Hightouch to create a household graph and a separate high-confidence people graph.",
            media: (
              <FillImage
                src={identitiesAccordionImage4}
                alt="Illustration showing five separate data tables, each with four rows of unique identities."
              />
            ),
          },
        ]}
      />
    </SolidPlate>
  );
}
